export const css = {
    root: '_25NAfQwM',
    splash: '_3Ze-LthO',
    progressBar: '_32nwzRVy',
    ' _key': 'apic-theme/apic/lcc-app/splash'
};
export default css;
